import { Box, Icon, Text } from '@chakra-ui/react';
import { BiRightArrowAlt } from 'react-icons/bi';

export const SubmitFormBtn = ({ children, isDisabled, ...restProps }: any) => {
  return (
    <Box
      as='button'
      minH={['53px', '68px']}
      pl={25}
      pr='55px'
      mr='25px'
      color={isDisabled ? 'whiteAlpha.600' : 'brand.white'}
      fontSize='lg'
      fontWeight='bold'
      flexDirection='row'
      display='flex'
      alignItems='center'
      justifyContent='center'
      transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
      pointerEvents={isDisabled ? 'none' : 'initial'}
      position='relative'
      sx={{
        background: isDisabled
          ? '#CECECE'
          : 'linear-gradient(270deg, var(--chakra-colors-brand-gradientBlueLight) 0%, var(--chakra-colors-brand-gradientBlueDark) 100%) 0% 0%',
      }}
      _hover={{ opacity: 0.8 }}
      {...restProps}
    >
      <Text>{children}</Text>

      <Box
        bg={isDisabled ? 'brand.formPlaceholderColor' : 'brand.fontColor'}
        minH='100%'
        w='50px'
        right='-12px'
        sx={{ transform: 'skewX(-20deg)' }}
        position='absolute'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Icon
          as={BiRightArrowAlt}
          color={isDisabled ? 'whiteAlpha.600' : 'brand.cyan'}
          minH='100%'
          fontSize='2xl'
          sx={{ transform: 'skewX(20deg)' }}
        />
      </Box>
    </Box>
  );
};
